export const INPUT_NAMES = {
  surname: 'surnameRef',
  name: 'nameRef',
  patronymic: 'patronymicRef',
  date: 'dateRef',
  email: 'emailRef',
  cartNumber: 'cartNumberRef',
  phone: 'phoneRef',
} as const

export const REPORT_CREATION_MODE = {
  nullPatient: 'nullPatient',
  patientExists: 'patientExists',
  newPatient: 'newPatient',
} as const

export const TEETH_STONE = {
  stoneEmpty: 1,
  supragingivalUpOneThird: 2,
  supragingivalOverOneThird: 3,
  supragingivalOverTwoThird: 4,
  subgingival: 5,
} as const

export const REPORT_PAGE_NAME = {
  oldReport: 'OldReportPage',
  newReport: 'PlaqueIndexReportPage',
} as const
